import { receivingUnits } from './warehouse-units.mjs';

// Resolve against existing catalog; never create products or write draft/stock endpoints.
export async function resolveDraftExcel(api, rows, kind, supplier = {}) {
  const output = [], seen = new Set();
  for (const row of rows) {
    const fail = text => { throw new Error(`Baris ${row.row}: ${text}`); };
    const { data } = await api.get('/branch-transfers/products', { params: { q: row.barcode || row.name } });
    if (data.length >= 21) fail('pencarian terlalu luas; gunakan barcode unik.');
    const matches = data.filter(p => row.barcode ? p.exact : p.name.trim().toLowerCase() === row.name.toLowerCase());
    if (matches.length !== 1) fail(matches.length ? 'produk ambigu; gunakan barcode unik.' : 'produk tidak ditemukan. Periksa barcode/nama, tidak ada produk dibuat otomatis.');
    const p = matches[0];
    if (row.name && p.name.trim().toLowerCase() !== row.name.toLowerCase()) fail('barcode dan nama tidak cocok.');
    if (seen.has(p.id)) fail('produk duplikat dalam file. Gabungkan menjadi satu baris.');
    seen.add(p.id);
    const units = p.units.filter(u => u.name.toLowerCase() === row.unit.toLowerCase());
    if (units.length !== 1) fail('satuan tidak cocok/ambigu; gunakan satuan terdaftar di POS.');
    const unit = units[0];
    if (!Number.isSafeInteger(row.qty * Number(unit.pieces)) || row.qty * Number(unit.pieces) > 1000000) fail('jumlah satuan dasar melebihi batas 1.000.000.');
    if (kind === 'warehouse') {
      const { data: product } = await api.get('/warehouse/product', {params:{product_id:p.id, supplier_id:supplier.supplier_id || undefined, supplier_name:supplier.supplier_name}});
      // Do not silently lose variant identity: variant rows require manual selection.
      if (row.barcode && product.variants?.some(v => v.barcode === row.barcode)) fail('barcode varian harus dimasukkan melalui scan agar varian tetap tepat.');
      output.push({ product_id:p.id, product_name:p.name, barcode:product.barcode, base_unit:product.base_unit,
        units:receivingUnits(product), quantity:row.qty, unit:unit.name, pieces:unit.pieces, cost:null, condition:'SESUAI', variant:null });
    } else output.push({product_id:p.id, name:p.name, unit:unit.name, pieces:unit.pieces, qty:row.qty, unit_cost:Number(p.cost)*Number(unit.pieces)});
  }
  return output;
}

export function assertNewDraftRows(rows, existingIds) {
  if (rows.some(row => existingIds.includes(row.product_id))) throw new Error('Ada produk yang sudah ada di draf. Tidak ditambahkan agar QTY tidak ganda. Hapus baris duplikat dari file atau edit baris draf yang sudah ada.');
}
